export const documentTimestamp = () => {
  const date = new Date();
  var day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();
  const hour = date.getHours();
  const minutes = date.getMinutes();
  return `${day} ${month} ${year} ${hour}_${minutes}`;
};
